import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div<{ $isShow: boolean }>`
	width: 100%;
	height: 100%;
	display: ${(props) => (props.$isShow ? 'flex' : 'none')};
	flex-direction: column;
	gap: 1.5rem;
	align-items: flex-start;
	justify-content: center;
`;

export const boxGrids = styled.div`
	width: 99%;
`;

export const actions = styled.div`
	position: absolute;
	top: 1rem;
	right: 1rem;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: row;
	gap: 1rem;

	> div {
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 3px;
		background-color: ${color.interface.white};
		border-radius: 50%;
		> svg {
			cursor: pointer;
			font-size: 20px;
		}

		-webkit-box-shadow: 0px 0px 15px -3px rgba(0, 0, 0, 0.75);
		-moz-box-shadow: 0px 0px 15px -3px rgba(0, 0, 0, 0.75);
		box-shadow: 0px 0px 15px -3px rgba(0, 0, 0, 0.75);
	}
`;
